// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderSummaryCardStyles } from "@synd/Overrides/Components/OrderSummaryCard";
import LinkReorder from "@synd/XDL/Icons/LinkReorder";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { createLinkIconStyles } from "@synd/XDL/Utilities";
import { css } from "styled-components";


orderSummaryCardStyles.actionsCells = {
    mergeCss: true,
    css: css`
        display: flex;
        justify-content: center;
    `
};

orderSummaryCardStyles.reorderButton = {
    variant: "link" as any,
        icon: {
            src: LinkReorder,
            position: "left",
        },
};

orderSummaryCardStyles.reorderButtonSpinner = {
    size: 13,
}